import axios from "axios";
import React, {useEffect, useState, useRef, Fragment} from "react";
import {Link, NavLink, useParams, useNavigate, useLocation} from "react-router-dom"
import {render} from "react-dom";
import clientconfigwebapp, {
    empty_bk, redirectbh,
    is_phone_hk,
    convert_to_english_strhk,
    scrollTo_uphk,
    show_menu_hh,
    check_login_appbk, Token_get_appbk, FormatNumberByhkh,
} from '../../clientconfigwebapp';
import Master_Front from "../../pages/Master_Front";
import {ToastContainer, toast} from 'react-toastify';

import ReactFullPageLoadinghk from "../../components/layaout/LoadingFullpagehk";
import Grid from '@mui/material/Grid';
import {Button} from "@mui/material";
import "../../assets/css/Check-out.css"
import LazyLoad from "react-lazy-load";

const serialize = require('form-serialize');


const Checkout_post = () => {
    const location_get_urlbk = useLocation();
    const redirect_navigate = useNavigate();


    /*  start profile */
    const [wallet_balance, setData_wallet_balance] = useState('0');
    const [first_name_profile, setData_first_name_profile] = useState('');
    const [last_name_profile, setData_last_name_profile] = useState('');
    const [show_mesaage_buy, setData_show_mesaage_buy] = useState('hide');
    /*  end profile */


    const [loadinghkfullshow, Setloadinghkfullshow] = useState("false");
    const [discount_code, Set_discount_code] = useState("");
    const [discount_price, Set_discount_price] = useState("");
    const [discount_text_show, Set_discount_text_show] = useState("");
    const [data_checkoutinfo, Setdata_checkoutinfo] = useState([]);

    const {id_post_getuser} = useParams();

    const containerStyle = {
        backgroundColor: 'white',
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        marginTop: '25px',
        borderRadius: '8px',
        paddingRight: '25px',
        paddingLeft: '26px',
        width: '77%',
        marginRight: '11%',
    };

    const imageStyle = {
        borderRadius: '10px',
        border: '2px solid rgb(237, 233, 233)',
        marginRight: '14px',
        width: '96%',
        position: 'relative',
        top: '-25px',
    };


    useEffect(() => {
        scrollTo_uphk();
        if (check_login_appbk() == false) {
            redirect_navigate("/login", {replace: true});
        }
        Load_api_page();

    }, [location_get_urlbk]);

    const Load_api_page = () => {

        const data_form = {post_id: id_post_getuser, discount_code: discount_code};
        const config = {
            headers: {Authorization: `Bearer ${Token_get_appbk()}`}
        };

        Setloadinghkfullshow("true");

        Set_discount_text_show("");

        axios.post(`${clientconfigwebapp.siteurl}api/v1/check-out-get-info-post`, data_form, config)
            .then((res) => {

                Setloadinghkfullshow("false");


                if (String(res.data.wallet_inventory).length > 0) {
                    setData_wallet_balance(res.data.wallet_inventory);
                }
                if (!empty_bk(res.data.first_name_profile)) {
                    setData_first_name_profile(res.data.first_name_profile);
                    localStorage.setItem('first_name_Get', res.data.first_name_profile);
                }
                if (!empty_bk(res.data.last_name_profile)) {
                    setData_last_name_profile(res.data.last_name_profile);
                    localStorage.setItem('last_name_Get', res.data.last_name_profile);
                }


                if (String(res.data.data) == "buypost") {
                    setData_show_mesaage_buy("show");


                } else {

                    setData_show_mesaage_buy("hide");

                    if (String(res.data.data).length > 0) {


                        if (String(res.data.data[0]).length > 0) {

                            Setdata_checkoutinfo(res.data.data[0]);

                            if (!empty_bk(data_checkoutinfo.price_discount)) {
                                Set_discount_price(String(data_checkoutinfo.price_discount))
                            }


                            if (!empty_bk(data_checkoutinfo.discount_text_show)) {
                                Set_discount_text_show(String(data_checkoutinfo.discount_text_show));

                            }


                            if (!empty_bk(data_checkoutinfo.discount_message_box)) {
                                toast.success(String(data_checkoutinfo.discount_message_box), {
                                    position: "top-center",
                                    autoClose: 5000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                            }


                        }


                    } else {
                        if (String(res.data.msgwebapp).length > 0) toast.error(res.data.msgwebapp, {
                            position: "top-center",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }

                }


            }).catch((err) => {
            Setloadinghkfullshow("false");
            toast.error('خطای اتصال به سرور کد 345436', {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        });

    }


    const Redirect_user_togetway_saman = (token_Get, RedirectURL) => {


        var form = document.createElement("form");
        form.setAttribute("method", "POST");
        form.setAttribute("action", "https://sep.shaparak.ir/payment.aspx");
        form.setAttribute("target", "_self");
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("name", "token");
        hiddenField.setAttribute("value", String(token_Get));
        form.appendChild(hiddenField);
        var hiddenField2 = document.createElement("input");
        hiddenField2.setAttribute("name", "RedirectURL");
        hiddenField2.setAttribute("value", String(RedirectURL));
        form.appendChild(hiddenField2);
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    }


    const Handlerpay_req = () => {
///باید قبل return باشه


        ///  const validateResult =  validate_form_Login();
        const validateResult = true;

        if (validateResult) {

            let form_data = document.querySelector('#form_checkout');

            if (form_data != null) {
                let data_serialize = serialize(form_data);

                Setloadinghkfullshow("true");

                const config = {
                    headers: {Authorization: `Bearer ${Token_get_appbk()}`}
                };


                axios.post(`${clientconfigwebapp.siteurl}api/v1/check-out-pay-post`, data_serialize, config)
                    .then((res) => {
                        Setloadinghkfullshow("false");
                        console.log(res.data, "ddddddataget");
                        if (String(res.data.data) == "login-show") {
                            redirect_navigate("/login", {replace: true});
                        }
                        if (!empty_bk(res.data.data)) {

                            if (String(res.data.data) != "wallet") {

                                if (res.data.get_way == "saman") {

                                    Redirect_user_togetway_saman(String(res.data.tok_way), String(res.data.RedirectURL));

                                } else if (res.data.get_way == "zarinpal") {
                                    global.window.location.href = String(res.data.data);

                                } else if (res.data.get_way == "wallet") {
///dddddddddd
                                    redirect_navigate("/panel/my-courses");
                                    toast.success("سفارش با موفقیت ثبت شد", {
                                        position: "top-center",
                                        autoClose: 5000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                        progress: undefined,
                                    });
                                }


                            } else {

                                if (res.data.get_way == "wallet") {

                                    redirect_navigate("/panel/my-courses");
                                    toast.success("سفارش با موفقیت ثبت شد", {
                                        position: "top-center",
                                        autoClose: 5000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                        progress: undefined,
                                    });
                                }


                            }

                        } else {
                            Setloadinghkfullshow("false");
                            toast.error(res.data.msgwebapp, {
                                position: "top-center",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });

                        }

                    }).catch((err) => {
                    Setloadinghkfullshow("false");
                    toast.error('خطای اتصال به سرور کد 5431', {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    console.error(err, "is error 5431!");

                });


            } else {

                alert('errcode:6456546');
            }

        }


    }


    const discont_Handler = (event) => {
        Set_discount_code(convert_to_english_strhk(event.target.value));
    }


    return (
        <>
            <Master_Front custom_class_main={"bg-gray-bk"} wallet_balance={wallet_balance}
                          first_name_profile={first_name_profile} last_name_profile={last_name_profile}>


                <ReactFullPageLoadinghk loadinghk={loadinghkfullshow}/>


                {

                    (() => {


                        if (check_login_appbk() == true && show_mesaage_buy == "hide") {

                            return (

                                <Fragment>

                                    <div style={{
                                        "display": "flex",
                                        "flexDirection": "column",
                                        "justifyContent": "center",
                                        "alignItems": "center"
                                    }}>
                                        <form name="form_checkout" id="form_checkout">
                                            <input type="text" name="post_id" value={id_post_getuser}
                                                   style={{"display": "none"}}/>
                                            <div style={{
                                                "backgroundColor": "white",
                                                "padding": "12px",
                                                "borderRadius": "14px",
                                                "marginTop": "10vh",
                                                "marginBottom": "10vh"
                                            }}>


                                                <div>


                                                    <div style={{"position": "relative"}}>
                                                        <img style={{
                                                            "border": "5px solid rgb(235 235 235)",
                                                            "position": "relative",
                                                            "width": "74%",
                                                            "marginRight": "12%",
                                                            "top": "-40px",
                                                            "borderRadius": "13px"
                                                        }} src={data_checkoutinfo.image_src} alt=""/>
                                                    </div>


                                                    <div style={{
                                                        "paddingTop": "0px",
                                                        "paddingBottom": "31px",
                                                        "paddingRight": "7px",
                                                        "fontSize": "15px",
                                                        "textAlign": "center",
                                                        "fontWeight": "bold",
                                                        "lineHeight": "1.6"
                                                    }}>{data_checkoutinfo.title_post}</div>


                                                    <div style={{
                                                        "marginBottom": "11px",
                                                        "display": "block",
                                                        "padding": "12px",
                                                        "borderRadius": "10px",
                                                        "marginTop": "10px",
                                                        "backgroundColor": "#fbfbfb",
                                                        "border": "solid 1px #f5f1f1"
                                                    }}>

                                                        <div>
                                                            <span>کد تخفیف</span>
                                                        </div>


                                                        <input onChange={discont_Handler} type="text" id="discount_code"
                                                               name="discount_code" value={discount_code} style={{
                                                            "background": "rgb(244, 244, 244)",
                                                            "borderRadius": "10px",
                                                            "border": "none",
                                                            "marginTop": "13px",
                                                            "height": "50px",
                                                            "width": "66%"
                                                        }}/>

                                                        <Button onClick={Load_api_page} style={{
                                                            "background": "#388ac8",
                                                            "borderRadius": "10px",
                                                            "color": "white",
                                                            "fontFamily": "iran",
                                                            "width": "32%",
                                                            "marginRight": "2%",
                                                            "height": "50px",
                                                            "position": "relative",
                                                            "top": "-1px",
                                                            "fontSize": "13px"
                                                        }}>اعمال کد</Button>


                                                    </div>


                                                </div>


                                                <div className="items-factor-checkout" style={{
                                                    "marginBottom": "5px",
                                                    "display": "block",
                                                    "padding": "12px",
                                                    "border": "solid 1px #ede4e4",
                                                    "borderRadius": "10px",
                                                    "paddingBottom": "25px"
                                                }}>

                                                    <div className="flexRowBetCenter"
                                                         style={{"paddingBottom": "13px", "paddingTop": "10px"}}>
                                                        <span
                                                            style={{'display': empty_bk(data_checkoutinfo.price_line) || String(data_checkoutinfo.price_line) == "0" ? ('none') : ('inline-block')}}><del
                                                            style={{
                                                                "fontSize": "12px",
                                                                "paddingLeft": "10px",
                                                                "color": "#949090"
                                                            }}>{FormatNumberByhkh(data_checkoutinfo.price_line, ".", ",")} تومان</del></span>
                                                        <span> مبلغ محصول: {FormatNumberByhkh(data_checkoutinfo.price_main, ".", ",")} تومان</span>
                                                    </div>

                                                    <div className="item-factor-checkout"> کد تخفیف
                                                        : {discount_text_show} </div>
                                                    <div className="item-factor-checkout" style={{
                                                        "color": "black",
                                                        "fontWeight": "bold",
                                                        "fontSize": "13px"
                                                    }}>مبلغ پرداختی
                                                        شما: {FormatNumberByhkh(data_checkoutinfo.price, ".", ",")} </div>


                                                </div>


                                                <div style={
                                                    {

                                                        backgroundColor: "#fbfbfb",
                                                        padding: "4px 14px 13px 12px",
                                                        borderRadius: "10px",
                                                        border: "solid 1px #e9e9e9",
                                                        display: data_checkoutinfo.price == "0" || data_checkoutinfo.price == 0 ? "none" : "block",
                                                    }

                                                }>



                                                    <span style={{
                                                        "marginTop": "28px",
                                                        "display": "block",
                                                        "fontStyle": "normal",
                                                        "fontWeight": "500",
                                                        "fontSize": "15px",
                                                        "lineHeight": "23px",
                                                        "textAlign": "right",
                                                        "color": "#334155"
                                                    }}>پرداخت با:</span>

                                                    <div className="box-item-gateway" style={{display: "block"}}>
                                                        <input type="radio" name="gateway" id="zarinpal"
                                                               value="zarinpal" checked/>
                                                        <label htmlFor="zarinpal">
            <span>
            <img src={clientconfigwebapp.webappurl + "images/icons/zarinpal.png"}/>
            </span>
                                                            <span style={{
                                                                "paddingRight": "50px",
                                                                "position": "relative",
                                                                "top": "-5px"
                                                            }}>درگاه زرین پال</span>
                                                        </label>
                                                    </div>

                                                    <div className="box-item-gateway" style={{display: "none"}}>
                                                        <input type="radio" name="gateway" id="saman" value="saman"/>
                                                        <label htmlFor="saman">
            <span>
            <img src={clientconfigwebapp.webappurl + "images/icons/sep-logo-small.png"}/>
            </span>
                                                            <span
                                                                style={{
                                                                    "paddingRight": "50px",
                                                                    "position": "relative",
                                                                    "top": "-5px"
                                                                }}>درگاه پرداخت سامان</span>
                                                        </label>
                                                    </div>


                                                    <div className="box-item-gateway">
                                                        <input type="radio" name="gateway" id="wallet" value="wallet"/>
                                                        <label htmlFor="wallet"><span style={{
                                                            "paddingRight": "15px",
                                                            "position": "relative",
                                                            "top": "-3px"
                                                        }}>کیف پول (موجودی {FormatNumberByhkh(data_checkoutinfo.wallet_balance, ".", ",")} تومان )</span></label>
                                                    </div>


                                                </div>

                                                <div style={{
                                                    "textAlign": "center",
                                                    "justifyContent": "center",
                                                    "display": "flex",
                                                    "paddingTop": "16px"
                                                }}>
                                                    <button type="button" className="btn-pay"
                                                            onClick={Handlerpay_req}>تایید عملیات
                                                    </button>
                                                </div>


                                            </div>
                                        </form>

                                    </div>
                                </Fragment>


                            )


                        }


                        if (check_login_appbk() == true && show_mesaage_buy == "show") {

                            return (

                                <Fragment>

                                    <div className={"boxmessage-buy"}>

                                        <div style={{
                                            "display": "block",
                                            "paddingBottom": "17px",
                                            "fontSize": "16px",
                                            "lineHeight": "1.6"
                                        }}>شما قبلا این دوره را تهیه کرده اید برای مشاهده وارد دوره های من شوید.
                                        </div>


                                        <a href={String(clientconfigwebapp.webappurl) + "panel/my-courses"} style={{
                                            "display": "flex",
                                            "flexDirection": "row",
                                            "alignContent": "center",
                                            "justifyContent": "center",
                                            "alignItems": "center",
                                            "backgroundColor": "#3b82f6",
                                            "width": "126px",
                                            "paddingTop": "8px",
                                            "paddingBottom": "6px",
                                            "borderRadius": "12px",
                                            "marginLeft": "9px",
                                            "flexWrap": "nowrap"
                                        }}>
                                            <svg style={{"width": "30px", "color": "white", "paddingLeft": "7px"}}
                                                 className="w-5 h-5 text-white bg-opacity-75" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                                <path fill="currentColor"
                                                      d="M510.4 435.4l-107.7-399.9C396.9 14.08 377.5 0 356.4 0c-4.111 0-8.294 .5313-12.46 1.641l-61.82 16.48c-5.885 1.57-11.14 4.258-15.78 7.633C258.3 10.51 242.4 0 224 0H160C151.2 0 143.1 2.531 136 6.656C128.9 2.531 120.8 0 112 0h-64C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h64c8.787 0 16.92-2.531 24-6.656C143.1 509.5 151.2 512 160 512h64c26.51 0 48-21.49 48-48V165.3l83.8 311.3C361.6 497.9 380.9 512 402.1 512c4.111 0 8.293-.5313 12.46-1.641l61.82-16.48C502 487 517.2 460.8 510.4 435.4zM224 48V96L160 96L160 48H224zM160 144h64v224H160V144zM112 368h-64v-224h64V368zM112 48V96h-64V48H112zM48 464V416h64v48H48zM160 464l.0011-47.1L224 416v48H160zM294.4 64.5l61.83-16.48l12.47 45.91L306.8 110.4L294.4 64.5zM319.3 156.6l61.91-16.51l58.04 215.3l-61.91 16.51L319.3 156.6zM402.2 464.1l-12.41-46.04l61.91-16.51l12.38 45.94L402.2 464.1z"/>
                                            </svg>
                                            <span style={{"color": "white", "fontSize": "13px"}}>دوره‌های من</span>
                                        </a>
                                        lll

                                    </div>
                                </Fragment>


                            )


                        }


                    })()

                }


            </Master_Front>

        </>
    );
}

export default Checkout_post;